import { folder, useControls } from "leva";
import { Canvas } from "@react-three/fiber";
import { PerformanceMonitor } from "@react-three/drei";
import { useEffect } from "react";
import { useExperienceStore } from "@/stores/useExperienceStore";
import { PerfState, usePerfManager } from "@/features/performance";
import { Debug, CanvasDebug } from "@/utils/components/Debug";
import { Model } from "./Model";
import { Controls } from "./Controls";
import { Scene } from "./Scene";

export function Experience() {
  const { upgrade, degrade, perfState, setState, autoUpdate, setAutoUpdate, isMonitorActive, setIsMonitorActive, settings } = usePerfManager(); //prettier-ignore
  const [, set] = useControls(
    () => ({
      Performance: folder(
        {
          isActive:    { value: isMonitorActive, onChange: (v) => setIsMonitorActive(v) },
          autoUpdate:  { value: autoUpdate,      onChange: (v) => setAutoUpdate(v) },
          perfState:   { value: perfState.current, options: Object.fromEntries(Object.entries(PerfState).filter(([k]) => isNaN(Number(k)))), onChange: (v) => setState(v) }, //prettier-ignore
        },
        { collapsed: true }
      ),
    }),
    [perfState]
  );

  useEffect(() => set({ perfState: perfState.current } as any), [perfState, set]); // sync Leva with external perfState changes

  return (
    <>
      <Canvas
        shadows
        dpr={[1, settings.dpr]}
        className="r3f"
        style={{ position: "fixed", top: "50%", left: "50%", zIndex: 1, transform: "translate(-50%, -50%)", width: "100vw", height: "100vh", overflow: "hidden" }}
        onCreated={(state) => {
          useExperienceStore.getState().setCanvas({ domElement: state.gl.domElement });
          useExperienceStore.getState().setThree({ gl: state.gl, scene: state.scene, camera: state.camera });
        }}
      >
        <PerformanceMonitor onIncline={upgrade} onDecline={degrade} />
        <Scene>
          <Controls />
          <Model />
        </Scene>
        <CanvasDebug />
      </Canvas>
      <Debug />
    </>
  );
}
